import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeTrailerMovement } from './normalize';

export const fetchTrailerMovement = createProvider(api.fetchTrailerMovement)
  .andThen((res) => normalizeTrailerMovement(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
